import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { getLiveState } from '../store/selectors/liveSelector';
import Live from '../Live';
import initContainerData from 'bdata-react-component/lib/store/initContainerData';
import liveReducer from '../store/reducers/live';
import playTimerReducer from '@gameday/utils/reducers/playTimer';
import { routes as TeamSummaryMatchupRoutes } from '../../TeamSummaryMatchup/TeamSummaryMatchupDataContainer';
import { routes as LiveFeedRoutes } from '../../LiveFeed/containers/LiveFeedDataContainer';
import { routes as SummaryRoutes } from '../../Summary/containers/SummaryDataContainer';
import { routes as AtBatRoutes } from '../../AtBat/containers/AtBatDataContainer';
import { routes as FieldVisionRoutes } from '../../FieldVision/containers/FieldVisionButtonDataContainer';
import { routes as HighlightsPlaylistRoutes } from '../../HighlightsPlaylist/containers/HighlightsPlaylistDataContainer';
import { routes as GameOverRoutes } from '../../GameOver/containers/GameOverDataContainer';
import { routes as PitchFXRoutes } from '../../PitchFx/PitchFxDataContainer';
import { routes as PlayerDuelRoutes } from '../../PlayerDuel/containers/PlayerDuelDataContainer';

import { getPlayIndex } from '../../../utils/selectors/getPlayIndex';
import ErrorBoundaryWrapper from '../../ErrorFallback/ErrorBoundaryWrapper';

initContainerData.register({
    reducers: {
        live: liveReducer,
        playTimer: playTimerReducer
    }
});

const routes = [{
    path: '/:teams?/:year?/:month?/:day?/:gamepk/live/:tab?/:detail?',
    exact: false,
    routes: [
        ...PitchFXRoutes,
        ...TeamSummaryMatchupRoutes,
        ...LiveFeedRoutes,
        ...SummaryRoutes,
        ...AtBatRoutes,
        ...FieldVisionRoutes,
        ...HighlightsPlaylistRoutes,
        ...GameOverRoutes,
        ...PlayerDuelRoutes
    ]
}];

const LiveContainer = ({ handleViewChange }) => {
    const liveState = useSelector(getLiveState);
    const retrievedAtBatPlayIndex = useSelector(getPlayIndex);

    return (
        <ErrorBoundaryWrapper componentName='Live'>
            <Live handleViewChange={handleViewChange} {...liveState} retrievedAtBatPlayIndex={retrievedAtBatPlayIndex} />
        </ErrorBoundaryWrapper>
    );
};

LiveContainer.propTypes = {
    handleViewChange: PropTypes.func
};

export default LiveContainer;
export { routes };
